import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  BackButton,
  MobilePopoverCard,
  MobileFloatingButton,
  EmailInputField,
} from "halifax";
import { IPerson } from "redmond";
import { Divider, Typography } from "@material-ui/core";
import "./styles.scss";

export interface IMobileDriverContactInfoWorkflowProps {
  onGoBack: () => void;
  open: boolean;
  onClickContinue: (email: string) => void;
  mobileHeaderElement?: JSX.Element;
  className?: string;
  driver: IPerson | undefined;
}

export const MobileDriverContactInfoWorkflow = ({
  onGoBack,
  open,
  onClickContinue,
  mobileHeaderElement,
  className,
  driver,
}: IMobileDriverContactInfoWorkflowProps): React.ReactElement => {
  const [contactEmail, setContactEmail] = useState<string>(
    () => driver?.emailAddress ?? ""
  );

  useEffect(() => {
    setContactEmail(driver?.emailAddress ?? "");
  }, [driver?.emailAddress]);

  const renderBackButton = () => (
    <BackButton
      className="driver-contact-info-back-button"
      onClick={onGoBack}
    />
  );

  return (
    <MobilePopoverCard
      open={open}
      className={clsx(
        "b2b mobile-driver-contact-info-workflow-root mobile",
        className
      )}
      fullScreen
      topLeftButton={renderBackButton()}
      headerElement={mobileHeaderElement}
    >
      <Typography component="h1" className="driver-contact-info-title">
        {driver ? `${driver.givenName} ${driver.surname}` : ""}
      </Typography>
      <Divider />
      <div className="form-container">
        <label htmlFor="contact-email-input-field">
          <Typography className="title" component="span">
            Contact information
          </Typography>
        </label>
        <Typography className="subtitle" variant="body2">
          A copy of the car rental confirmation email will be sent to this
          traveler.
        </Typography>
        <EmailInputField
          fullWidth
          onChange={(value) => {
            setContactEmail(value);
          }}
          email={contactEmail}
        />
      </div>

      <MobileFloatingButton
        className="driver-contact-info-workflow-continue-button"
        wrapperClassName="driver-contact-info-workflow-continue-button-container"
        onClick={() => {
          onClickContinue(contactEmail);
        }}
      >
        Continue
      </MobileFloatingButton>
    </MobilePopoverCard>
  );
};
